module.exports = __webpack_public_path__ + "img/17-20.4d4ec4e9.jpg";